export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">欢迎通过以下方式与我们取得联系，期待您的宝贵建议与投稿</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group">
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
              <i className="ri-mail-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-base text-foreground-900 mb-2">商务合作</h3>
            <p className="text-foreground-500 text-xs leading-relaxed">bd@bananatv.com</p>
          </div>

          <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all cursor-pointer group">
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-4 group-hover:bg-accent-500 group-hover:text-white transition-colors">
              <i className="ri-chat-smile-2-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-base text-foreground-900 mb-2">内容投稿</h3>
            <p className="text-foreground-500 text-xs leading-relaxed">content@bananatv.com</p>
          </div>

          <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-secondary-200 transition-all cursor-pointer group">
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mb-4 group-hover:bg-secondary-500 group-hover:text-white transition-colors">
              <i className="ri-question-answer-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-base text-foreground-900 mb-2">用户反馈</h3>
            <p className="text-foreground-500 text-xs leading-relaxed">feedback@bananatv.com</p>
          </div>
        </div>

        <p className="text-center text-foreground-400 text-xs mt-6">
          工作时间：周一至周日 9:00 - 22:00，我们会在24小时内回复您的邮件
        </p>
      </div>
    </section>
  );
}